import { render } from "./addCards.vue?vue&type=template&id=58fad728&scoped=true"
import script from "./addCards.vue?vue&type=script&lang=js"
export * from "./addCards.vue?vue&type=script&lang=js"

import "./addCards.vue?vue&type=style&index=0&id=58fad728&lang=scss&scoped=true"
import "./addCards.vue?vue&type=style&index=1&id=58fad728&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fad728"]])

export default __exports__